import { ArrowUpRight, Youtube } from 'lucide-react';
import { ABOUT } from '../data/about';
import { CONTENT } from '../data/content';
import { PageSection, SectionHeader } from './SectionHeader';
import { trackEvent } from '../utils/analytics';

export default function About() {
  return (
    <PageSection id="about">
      <SectionHeader index="03" label="About" title={ABOUT.headline} />

      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="reveal lg:col-span-5 order-2 lg:order-1">
          <div className="card overflow-hidden group">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src="/images/profile.png"
                alt="Janmesh Joshi working on a laptop outdoors in the Irish hills"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover grayscale contrast-[1.05] transition-[filter,transform] duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:grayscale-0 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-surface via-transparent to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-6 flex items-end justify-between">
                <div>
                  <p className="label text-ink/70">{ABOUT.photo.label}</p>
                  <p className="mt-1 font-serif italic text-2xl text-ink">{ABOUT.photo.caption}</p>
                </div>
              </div>
            </div>
          </div>

          <a
            href={CONTENT.channelUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="card card-hover group mt-4 flex items-center gap-4 p-5"
            onClick={() => trackEvent('contact_click', { method: 'YouTube', source: 'about' })}
          >
            <span className="h-11 w-11 shrink-0 rounded-full bg-accent/10 border border-accent/25 flex items-center justify-center text-accent">
              <Youtube size={18} aria-hidden="true" />
            </span>
            <span className="flex-1 min-w-0">
              <span className="block text-sm font-medium text-ink">{CONTENT.channelHandle}</span>
              <span className="block mt-0.5 text-xs text-muted truncate">{CONTENT.description}</span>
            </span>
            <ArrowUpRight size={16} className="text-faint group-hover:text-ink transition-colors" aria-hidden="true" />
          </a>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="reveal prose-muted text-base sm:text-[17px] leading-relaxed text-muted" style={{ '--d': '80ms' }}>
            {ABOUT.paragraphs.map((p, i) => (
              <p key={p.slice(0, 24)} className={i === 0 ? 'text-ink/90 text-lg sm:text-xl leading-relaxed' : ''}>
                {p}
              </p>
            ))}
          </div>

          <dl className="reveal mt-10 grid sm:grid-cols-2 gap-px bg-line rounded-2xl overflow-hidden border border-line" style={{ '--d': '160ms' }}>
            {ABOUT.facts.map((f) => (
              <div key={f.label} className="bg-surface p-5">
                <dt className="label">{f.label}</dt>
                <dd className="mt-2 text-sm text-ink leading-snug">{f.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </PageSection>
  );
}
